var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99886 0L6 3.99802L4.00114 8H0L1.99886 3.99802L4.00114 0H7.99886Z",
    fill: "#FF4D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0H16.0011L14.0023 3.99802L12 8L10.0011 11.998L7.99886 16L6 19.998L4.00114 24H0L1.99886 19.998L4.00114 16L6 11.998L7.99886 8L10.0011 3.99802L12 0Z",
    fill: "#FFB400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0023 0H24L22.0011 3.99802L20.0023 8L18 11.998L16.0011 16L14.0023 19.998L12 24H7.99886L10.0011 19.998L12 16L14.0023 11.998L16.0011 8L18 3.99802L20.0023 0Z",
    fill: "#00A6ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0023 15.9999H24L22.0011 19.998L20.0023 23.9999H16.0011L18 19.998L20.0023 15.9999Z",
    fill: "#7FB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo24);
export default __webpack_public_path__ + "static/media/logo-24.67640c4ff67100bae803bf9866a864b2.svg";
export { ForwardRef as ReactComponent };